import { connect } from 'react-redux'
import FrenchCivilRegistryForm from './FrenchCivilRegistryForm.jsx'
import { getCollaborativeIndexationCreationFields } from '../../../../../../redux/collaborativeIndexations/selectors'

const mapStateToProps = (state) => ({
    fields: getCollaborativeIndexationCreationFields(state),
})

export const FrenchCivilRegistryFormContainer = connect(
    mapStateToProps,
)(FrenchCivilRegistryForm)
